import { render, staticRenderFns } from "./ConsortiumPage.vue?vue&type=template&id=308400b6&"
import script from "./ConsortiumPage.vue?vue&type=script&lang=js&"
export * from "./ConsortiumPage.vue?vue&type=script&lang=js&"
import style0 from "./ConsortiumPage.vue?vue&type=style&index=0&id=308400b6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports